type ContentState = 'draft' | 'published' | 'offline';

export function batchStateIds(
  rows: { id: string; state: ContentState }[],
  selectedIds: string[],
  target: 'published' | 'offline',
) {
  const selected = new Set(selectedIds);
  return rows
    .filter(
      (row) =>
        selected.has(row.id) &&
        (target === 'published' ? row.state !== 'published' : row.state === 'published'),
    )
    .map((row) => row.id);
}
